import React, {useEffect} from 'react';
import {useHistory, Link, generatePath} from "react-router-dom";
import { useDataValue } from 'globals/contexts/dataContext';
import routes from 'globals/routes';

import './artLanding.css';
import './artLandingMobile.css';
const ArtLanding = ({content: pageContent}) => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];
  const history = useHistory();
  // useEffect(() => {
  //   const logoEl = document.querySelector('#logo');
  //   logoEl.classList.add('hide');
  //   return () => {
  //     logoEl.classList.remove('hide');
  //   }
  // })
  const navigateTo = (filter) => {
    dispatch({
      type: 'pageTransitionStart',
    });
    setTimeout(() => {
      // const nextPage = currentPage === "index"? "commercial": "index";
      history.push(routes.pageWithLangAndFilter('art', currentLanguage, filter));
      // history.push(routes.artPageWithLangAndFilter(currentLanguage, filter));

      dispatch({
        type: 'pageTransitionEnd',
        // data: newStatus
      });
      // dispatch({
      //   type: 'pageTransitionEnd',
      // });
    }, 1500);
  }
  return <section className="artLanding">
    <div className="coverMedia">
    {{
      video: <video className="coverVideo" src={pageContent['background']['src']} autoPlay muted playsInline loop />,
      image: <img className="coverImage" src={pageContent['background']['src']} />
    }[pageContent['background']['type']]}
    </div>
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    <div className="introduction" dangerouslySetInnerHTML={{
      __html: pageContent['introduction']
    }} />
    <div className="filtersWrapper">
      <div className="filterLabel">{pageContent['filterLabel']}</div>
      <div className="filters">
        {pageContent['filter'].map(item => {
          return <div key={item['type']}
            className="filter"
            onClick={() => navigateTo(item['type'])}
          >
            <div className="styleIcon" style={{
              backgroundImage: `url(${item['icon']})`
            }} />
            <div className="name">
              <div className="line1">{item['text']}</div>
              <div className="line2">{item['text2']}</div>
            </div>
            <div className="clickHint">{pageContent['buttonLabel']}</div>
          </div>
        })}
      </div>
    </div>
  </section>;
}

export default ArtLanding;